import React , { useRef } from "react";
import emailjs from '@emailjs/browser';  
import "../Contact/Contacto.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faMapMarkerAlt, faClock } from "@fortawesome/free-solid-svg-icons";

const Contacto = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_2m9hs9f', 'template_rcegwfa', form.current, {
        publicKey: 'mlpwj_ENzDh2YmGQP',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          form.current.reset();
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };
  
  return (
    <div className="contactanos-container">
      <div className="contactanos-content">
        <div className="contactanos-info">
          <h2>Contáctanos</h2>
          <p>
            Estamos aquí para responder tus preguntas y ayudarte en lo que necesites. 
            No dudes en comunicarte con nosotros por los siguientes medios:
          </p>
          <ul>
            <li>
              <FontAwesomeIcon icon={faEnvelope} />{" "}
              <a href="mailto:ventas@coberturaglobal.com.pe"> ventas@coberturaglobal.com.pe </a>
            </li>
            <li>
            <FontAwesomeIcon icon={faEnvelope} />{" "}
              <a href="mailto:pedidos@coberturaglobal.com.pe"> pedidos@coberturaglobal.com.pe </a>
            </li>
            <li>
              <FontAwesomeIcon icon={faPhone} />  +51 976 492 175 / +51 949 230 744
            </li>
            <li>
              <FontAwesomeIcon icon={faMapMarkerAlt} />  Oficina: Cal.Coop Viv Familias Unidas Mza. D Lote. 13 Zona B (Espalda De Metro De Pedro Miota) Lima - San Juan De Miraflores
            </li>
            <li>
              <FontAwesomeIcon icon={faMapMarkerAlt} /> Jr. Cruz De Piedra Nro. 315 Bar. Cumbe Mayo
              (REF. Entré JR. Ancón) CAJAMARCA
            </li>
            <li>
              <FontAwesomeIcon icon={faClock} /> Lunes a Viernes: 8:00 AM - 6:00 PM / Sabados: 8:00 AM - 1:30 PM
            </li>
          </ul>
        </div>
        <form className="contactanos-form" ref={form} onSubmit={sendEmail}>
          <h2>Envíanos un mensaje</h2>
          <div className="form-group"> 
            <input type="text" placeholder="Nombre" name="user_name" required />
          </div>
          <div className="form-group">
            <input type="email" placeholder="Correo electrónico" name="user_email" required />
          </div>
          <div className="form-group">
            <textarea placeholder="Mensaje"  name="message" rows="5" required></textarea>
          </div>
          <button type="submit" value="Send" className="submit-button">
            Enviar Mensaje
          </button>
        </form>
      </div>
      <div className="contactanos-map">
        <iframe
          title="mapa"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9415.3815117705!2d-78.52819179168695!3d-7.162911052204667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91b25b1d59409d27%3A0x3d872184597ffdde!2sJTC%20DISTRIBUIDORA!5e0!3m2!1ses!2spe!4v1737836758459!5m2!1ses!2spe"
          width="100%"
          height="450"
          style={{ border: "0" }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default Contacto;
